import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {  signIn } from "../../utils/authHelpers"; 
import { gql, useLazyQuery } from "@apollo/client";

const HAS_SEEN_TUTORIAL = gql`
  query HasSeenTutorial {
  hasSeenTutorial
  }
`;

const LoginPage = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); 
  const [isReturning, setIsReturning] = useState(false);
  const [hasSeenTutorial, { loading: tutLoading, error: tutError }] =
      useLazyQuery(HAS_SEEN_TUTORIAL, { fetchPolicy: "no-cache", skip: true });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); 
    setLoading(true); 

    try {
      await signIn(email, password);
      setIsAuthenticated(true);

      // Check if user has seen tutorial
      const { data } = await hasSeenTutorial();
			if (data.hasSeenTutorial === true) { 
        // Returning user, take them to home
        console.log(">>>>>> User has seen tutorial, redirecting to home.");
				setIsReturning(true);
        navigate("/home");
			} else {
        // New user, take them to tutorial
        console.log(">>>>>> User has NOT seen tutorial, redirecting to howto.");
				setIsReturning(false);
        navigate("/howto");
			}
      
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Failed to log in. Please try again.");
    } finally {
      setLoading(false); 
    }
  };

  const handleForgotPasswordRedirect = () => {
    const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
    const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

    const forgotPasswordUrl = `https://${COGNITO_DOMAIN}/forgotPassword?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}`;
    window.location.href = forgotPasswordUrl;
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#2F2D2D] text-white">
      <div className="w-full max-w-md p-8 space-y-6 bg-[#2F2D2D] rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold text-center">Login to Pounce</h1>

        {error && <p className="text-red-500 text-center">{error}</p>}

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="flex flex-col">
            <label className="text-[#65DEF6] mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 bg-gray-800 rounded-lg border border-gray-600 text-white"
              required
            />
          </div>

          <div className="flex flex-col">
            <label className="text-[#65DEF6] mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 bg-gray-800 rounded-lg border border-gray-600 text-white"
              required
            />
            
            <p
            className="text-sm text-[#65DEF6] cursor-pointer hover:underline text-right mt-1"
            onClick={handleForgotPasswordRedirect}
          >
            Forgot Password?
          </p>

          </div>

          <button
            type="submit"
            className="w-full bg-[#C6E675] text-gray-900 font-bold py-3 px-4 rounded-lg hover:bg-[#4C9B8C] transition"
            disabled={loading} // Disable the button if loading
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="text-gray-400 text-sm text-center">
          Don't have an account?{" "}
          <span
            className="text-[#C6E675] hover:underline cursor-pointer font-semibold"
            onClick={() => navigate("/create-account")}
          >
            Sign up here
          </span>
        </p>

        {/* Dog Image (Bottom Right) */}
        <img
          src="/assets/images/puppy-2.png"
          alt="Dog Illustration"
          className="absolute w-[230.63px] h-[190.79px] bottom-[50px] right-[50px]"
        />
      </div>
    </div>
  );
};

export default LoginPage;
